import { format } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';

export const getAgendaDateInPreferredTimezone = (agendaTime: string, preferredTimezone: string): string => {
  return format(utcToZonedTime(agendaTime, preferredTimezone), 'yyyy-MM-dd');
};
